/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */

import findIndex from 'lodash/findIndex'
import groupBy from 'lodash/groupBy'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_CITIES } from '../../actions.type'
import {
  CREATE_CITY,
  REMOVE_CITY,
  SET_CITY_ALL_REQUEST,
  SET_CITY_ALL_VALUE,
  UPDATE_CITY
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  cityAllValue: (state) => state.all.value,
  cityAllRequest: (state) => state.all.request,
  cityAllById: (state) => keyBy(state.all.value, 'id'),
  cityAllByRegionId: (state) => groupBy(state.all.value, 'region.id')
}

const actions = {
  async [FETCH_CITIES]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('city', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_CITY_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_CITY_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_CITY_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_CITY_ALL_VALUE, data)
    } catch (e) {
      commit(SET_CITY_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_CITY({ commit }, value) {
    commit(CREATE_CITY, value)
  },

  async SOCKET_UPDATE_CITY({ commit }, value) {
    commit(UPDATE_CITY, value)
  },

  async SOCKET_REMOVE_CITY({ commit }, id) {
    commit(REMOVE_CITY, id)
  }
}

const mutations = {
  [SET_CITY_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_CITY_ALL_VALUE](state, cities) {
    state.all.value = cities
  },
  [UPDATE_CITY](state, updatedCity) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedCity.id }),
      1,
      updatedCity
    )
  },
  [CREATE_CITY](state, createdCity) {
    state.all.value.push(createdCity)
  },
  [REMOVE_CITY](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
